/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ionic-angular/components/popover/popover-component';
import * as import2 from 'ionic-angular/components/backdrop/backdrop';
import * as import3 from 'ionic-angular/config/config';
import * as import4 from 'ionic-angular/navigation/nav-params';
import * as import5 from 'ionic-angular/navigation/view-controller';
import * as import6 from 'ionic-angular/gestures/gesture-controller';
import * as import7 from 'ionic-angular/util/module-loader';
const styles_PopoverCmp:any[] = ([] as any[]);
export const RenderType_PopoverCmp:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_PopoverCmp,
  data: {}
}
);
export function View_PopoverCmp_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{_viewport: 0}),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'ion-backdrop',[
      [
        'disable-activated',
        ''
      ]
      ,
      [
        'role',
        'presentation'
      ]
      ,
      [
        'tappable',
        ''
      ]

    ]
      ,[[
        8,
        'hidden',
        0
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import1.PopoverCmp = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co._bdClick()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import2.Backdrop,[
      import0.ElementRef,
      import0.Renderer
    ]
    ,(null as any),(null as any)),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'popover-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'popover-arrow'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'popover-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'popover-viewport'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵeld(16777216,[
      [
        1,
        3
      ]
      ,
      [
        'viewport',
        1
      ]

    ]
      ,(null as any),0,'div',[[
        'nav-viewport',
        ''
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any)))
  ]
  ,(null as any),(ck,v) => {
    var co:import1.PopoverCmp = v.component;
    const currVal_0:boolean = !co.d.showBackdrop;
    ck(v,1,0,currVal_0);
  });
}
function View_PopoverCmp_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'ion-popover',([] as any[]),(null as any),[[
        'body',
        'keyup'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('body:keyup' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1)._keyUp($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },View_PopoverCmp_0,RenderType_PopoverCmp)),
    import0.ɵdid(180224,(null as any),0,import1.PopoverCmp,[
      import0.ComponentFactoryResolver,
      import0.ElementRef,
      import0.Renderer,
      import3.Config,
      import4.NavParams,
      import5.ViewController,
      import6.GestureController,
      import7.ModuleLoader
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const PopoverCmpNgFactory:import0.ComponentFactory<import1.PopoverCmp> = import0.ɵccf('ion-popover',import1.PopoverCmp,View_PopoverCmp_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL25vZGVfbW9kdWxlcy9pb25pYy1hbmd1bGFyL2NvbXBvbmVudHMvcG9wb3Zlci9wb3BvdmVyLWNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3J1bm5lci93b3JrL3dlYi1vcmRlcmluZy1hcHAvd2ViLW9yZGVyaW5nLWFwcC9ub2RlX21vZHVsZXMvaW9uaWMtYW5ndWxhci9jb21wb25lbnRzL3BvcG92ZXIvcG9wb3Zlci1jb21wb25lbnQuZC50cyIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL25vZGVfbW9kdWxlcy9pb25pYy1hbmd1bGFyL2NvbXBvbmVudHMvcG9wb3Zlci9wb3BvdmVyLWNvbXBvbmVudC5kLnRzLlBvcG92ZXJDbXAuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL25vZGVfbW9kdWxlcy9pb25pYy1hbmd1bGFyL2NvbXBvbmVudHMvcG9wb3Zlci9wb3BvdmVyLWNvbXBvbmVudC5kLnRzLlBvcG92ZXJDbXBfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8aW9uLWJhY2tkcm9wIChjbGljayk9XCJfYmRDbGljaygpXCIgW2hpZGRlbl09XCIhZC5zaG93QmFja2Ryb3BcIj48L2lvbi1iYWNrZHJvcD48ZGl2IGNsYXNzPVwicG9wb3Zlci13cmFwcGVyXCI+PGRpdiBjbGFzcz1cInBvcG92ZXItYXJyb3dcIj48L2Rpdj48ZGl2IGNsYXNzPVwicG9wb3Zlci1jb250ZW50XCI+PGRpdiBjbGFzcz1cInBvcG92ZXItdmlld3BvcnRcIj48ZGl2ICN2aWV3cG9ydCBuYXYtdmlld3BvcnQ+PC9kaXY+PC9kaXY+PC9kaXY+PC9kaXY+IiwiPGlvbi1wb3BvdmVyPjwvaW9uLXBvcG92ZXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUNBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO09BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO01BQWM7UUFBQTtRQUFBO01BQUE7TUFBZDtJQUFBO2dCQUFBOzs7SUFBQTtLQUFBO01BQTZFO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBNkI7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFpQztRQUFBO1FBQUE7TUFBQTtJQUFBO01BQTZCO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBOEI7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7Ozs7SUFBbks7SUFBbkMsU0FBbUMsU0FBbkM7Ozs7O01DQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtJQUFBO2dCQUFBOzs7Ozs7Ozs7SUFBQTtLQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./node_modules/ionic-angular/components/popover/popover-component.ngfactory.ts